import { Service } from '@roc/feature-app-core';
import { Assignee, Attributes, ResultType, SaveTaskV2Request, Task, TaskV2Type, TaskDetails, TaskPriority, TaskScope, TaskStatus, TaskV2, UpdateTaskStatusAndAssigneeRequest, TaskStatusDB, UpdateReadOnlyTaskStatusAndAssigneeRequest } from '../types/generalTasksTypes';

const url = {
  GET_ALL_TASKS_GRID_FOR_LOAN: '/api/v1/taskV2/findByType1Grid',
  GET_ALL_TASKS_BY_ASIIGNEE_IDS_GRID: '/api/v1/tasks/generalTasks/getAllTasksByAssigneeIdsGrid',
  GET_ALL_TASKS_BY_ASIIGNEE_IDS_GRID_V2: '/api/v1/taskV2/getAllTasksByAssigneeIdsGrid',
  GET_MY_TASKS_GRID: '/api/v1/taskV2/getMyTasksGrid',
  GET_MY_LOAN_TASKS_GRID_GROUPED_BY_LOAN_ID: '/api/v1/taskV2/getMyLoanTasksGridGroupedByLoanId',
  GET_MY_OTHER_TASKS_GRID: '/api/v1/taskV2/getMyOtherTasksGrid',
  GET_MY_CRM_TASKS_GRID: '/api/v1/taskV2/getCRMTasksGrid',
  GET_TASK_BY_ID: '/api/v1/taskV2/findByTaskId',
  SAVE_TASK: '/api/v1/taskV2/saveTask',
  SAVE_TASK_FROM_CHAT_APP: '/api/v1/taskV2/saveTaskFromChatApp',
  SAVE_TASK_WITHOUT_REASSIGN: '/api/v1/tasks/generalTasks/saveTaskWithoutReassign',
  UPLOAD_ATTACHMENT: '/api/v1/taskV2/uploadTaskDocument',
  REMOVE_ATTACHMENT: '/api/v1/taskV2/taskDocuments/removeByTaskDocumentId',
  GET_ASSIGNEE_OPTIONS: '/api/v1/user/getUsersForGeneralTasksAssignees',
  GET_READ_ONLY_ASSIGNEE_OPTIONS: '/api/v1/user/getUserForReadOnlyTask',
  GET_SUPPORT_TASK_WATCHERS_OPTIONS: '/api/v1/user/getUsersForSupportTaskWatchers',
  DOCUMENT_DOWNLOAD: '/api/v1/taskV2/taskDocuments/downloadByTaskDocumentId',
  SAVE_COMMENTS: '/api/v1/tasks/generalTasks/saveComments',
  GET_LOAN_INFO: '/api/v1/tasks/generalTasks/getLoanInformation',
  DOES_TASK_CHAT_ROOM_EXIST: '/api/v1/vendor/twilio/taskChatRoomV2/doesTaskChatRoomExist',
  CREATE_TASK_CHAT_ROOM: '/api/v1/vendor/twilio/taskChatRoomV2/createTaskChatRoom',
  CREATE_LINE_ITEM_TASK_CHAT_ROOM: '/api/v1/vendor/twilio/taskChatRoomV2/createLineItemTaskChatRoom',
  ESCALATE_TASK_TO_MANAGER: '/api/v1/tasks/generalTasks/escalateTaskToManager',
  GET_ALLOWED_ESCALATION_ROLES: '/api/v1/tasks/generalTasks/getAllowedEscalationRoles',
  MOVE_TASK_TO_ROC: '/api/v1/loan/task/moveTaskToRoc',
  MOVE_TASK_TO_CAPITAL_PROVIDER: '/api/v1/loan/task/moveTaskToCapitalProvider',
  MARK_TASK_AS_COMPLETED: '/api/v1/loan/task/markTaskAsCompleted',
  MARK_TASK_AS_COMPLETED_V2: '/api/v1/taskV2/markTaskAsCompleted',
  MARK_TASK_AS_WAITING_ON_EXTERNAL: '/api/v1/loan/task/setWaitingOnExternalFlagTrue',
  PUT_TASK_TO_TPO: '/api/v1/loan/task/putTaskToTpo',
  MOVE_TASK_TO_CMT_SPECIALIST: '/api/v1/loan/task/moveTaskToCMTSpecialist',
  IS_TAMARISK_APPRAISAL: '/api/v1/loan/appraisal/isTamariskAppraisal',
  UPDATE_TASK_BASED_ON_LOAN_TASK: '/api/v1/taskV2/saveTask',
  GET_UNREAD_COUNT_MESSAGES: '/api/v1/vendor/twilio/chatRooms/getTotalUserTasksConversationsUnreadCount',
  GET_WATCHERS_OPTIONS: '/api/v1/taskV2/getUsersForTasksWatchers',
  GET_ACTIVE_CLOSING_CONDITION: '/api/v1/loan/task/getActiveClosingCondition',
  HAS_CLOSING_CONDITION: '/api/v1/taskV2/hasClosingCondition',
  IS_STATUS_CHANGE_READY: '/api/v1/taskV2/isStatusChangeReady',
  IS_TASK_STATUS_CHANGE_READY: '/api/v1/tasks/generalTasks/isTaskStatusChangeReady',
  IS_ASSIGNEE_CHANGE_VALID: '/api/v1/taskV2/isAssigneeChangeValid',
  ADD_LOAN_TASK: '/api/v1/tasks/generalTasks/addLoanTask',
  UPDATE_TASK_STATUS_UPDATE_REASON: '/api/v1/taskV2/updateStatusUpdateReason',
  GET_LOAN_TASK_SECTION_NAMES: '/api/v1/tasks/generalTasks/taskSectionsForALoan',
  GET_LOAN_TASK_CATEGORIES_NAMES: '/api/v1/taskV2/taskV2Category/getActiveCategoriesByLoanProcess',
  UPDATE_TASK_STATUS: '/api/v1/tasks/generalTasks/{{taskId}}/status',
  GET_LOAN_ACTORS_BY_LOAN_ID: '/api/v1/tasks/generalTasks/getLoanActorsByLoanId',
  ASSIGN_TASK_TO_OWNER: '/api/v1/taskV2/assignToOwner',
  ADD_TASK_NOTE: '/api/v1/taskV2/addTaskNote',
  GET_TASK_BY_LOAN_ID_AND_LOAN_TASK_NAME: '/api/v1/tasks/generalTasks/getTaskByLoanIdAndLoanTaskName',
  ESCALATE_TASK_BY_ID: '/api/v1/taskV2/escalateTask',
  MARK_TASK_AS_NOT_APPLICABLE: '/api/v1/taskV2/markTaskAsNotApplicable',
  UPDATE_TASK_STATUS_AND_ASSIGNEE: '/api/v1/taskV2/updateTaskStatusAndAssignee',
  UPDATE_READ_ONLY_TASK_STATUS_AND_ASSIGNEE: '/api/v1/taskV2/updateTaskStatusAndAssigneeReadOnly',
  UPDATE_INTERNAL_VALUATION_REPORT_TASK_STATUS_AND_ASSIGNEE: '/api/v1/taskV2/updateTaskStatusAndAssigneeReadOnlyIV',
  SAVE_INTERNAL_VALUATION_REVIEW_REASON: '/api/v1/taskV2/saveInternalValuationReviewReason',
  GET_INTERNAL_VALUATION_REASON_DROPDOWN: '/nportal/rest/priv/valuationReview/getInternalValuationReasonDropdown',
  GET_INTERNAL_VALUATION_CURRENT_REASON_DISPLAY: '/nportal/rest/priv/valuationReview/getInternalValuationCurrentReasonDisplay',
  GET_LOAN_TASKS_WITH_NOTES: '/api/v1/taskV2/getLoanTasksWithNotes',
  REALVAL_PHOTO_SOURCE: '/api/v1/taskV2/realValPhotoSource',
};
export class GeneralTasksService extends Service {

  getAllTasksGridForLoan(
    loanId: number,
    status: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    resultType: ResultType,
  ) {
    return this.get(
      url.GET_ALL_TASKS_GRID_FOR_LOAN,
      {
        type1: 'LOAN_ID',
        typeId1: loanId,
        status,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        resultType,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getAllTasksByAssigneeIdsGrid(
    loanId: number,
    status: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: any,
    dropdownFilters: any,
    resultType: ResultType,
  ) {
    return this.get(
      url.GET_ALL_TASKS_BY_ASIIGNEE_IDS_GRID_V2,
      {
        loanId,
        status,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        resultType,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getMyTasksGrid(
    loanId: number,
    status: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    type: string,
    taskScope: TaskScope,
    resultType: ResultType,
    lenderId?: number,
    showCompletedInLastThirtyDays?: boolean,
  ) {
    return this.get(
      url.GET_MY_TASKS_GRID,
      {
        page,
        pageSize,
        sortBy,
        sortDir,
        loanId,
        resultType,
        taskScope,
        status,
        filters,
        dropdownFilters,
        showCompletedInLastThirtyDays,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getMyLoanTasksGridGroupedByLoanId(
    loanId: number,
    status: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    lenderId?: number,
  ) {
    return this.get(
      url.GET_MY_LOAN_TASKS_GRID_GROUPED_BY_LOAN_ID,
      {
        loanId,
        status,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        lenderId,
      }
    );
  }

  getMyOtherTasksGrid(
    loanId: number,
    status: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    taskScope: TaskScope,
    lenderId?: number,
  ) {
    return this.get(
      url.GET_MY_OTHER_TASKS_GRID,
      {
        loanId,
        status,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        taskScope,
        lenderId,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getMyCRMTasksGrid(
    loanId: number,
    status: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    taskScope: TaskScope
  ) {
    return this.get(
      url.GET_MY_CRM_TASKS_GRID,
      {
        loanId,
        status,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        taskScope,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getTaskById(taskId: number, disableGlobalLoading = false) {
    return this.get(url.GET_TASK_BY_ID, { taskId }, { disableGlobalLoading });
  }

  createTaskChatRoom(task: TaskV2) {
    const body = {
      taskId: task.taskId,
      loanId: task.loanId,
      assigneeUserId: task.taskAssignees[0]?.assigneeId,
      reporterUserId: task.ownerId,
      chatRoomName: task.title,
      propertyId: task.propertyId,
      watcherUserIds: task.taskWatchers?.map(watcher => watcher.userId) || [],
    }
    return this.post(url.CREATE_TASK_CHAT_ROOM, body);
  }

  createLineItemTaskChatRoom(task: TaskV2) {
    const body = {
      taskId: task.taskId,
      loanId: task.loanId,
      assigneeUserId: task.taskAssignees[0]?.assigneeId,
      reporterUserId: task.ownerId,
      chatRoomName: task.title,
      propertyId: task.propertyId,
      watcherUserIds: task.taskWatchers?.map(watcher => watcher.userId) || [],
    }
    return this.post(`${url.CREATE_LINE_ITEM_TASK_CHAT_ROOM}`, body);
  }

  doesTaskChatRoomExist(taskId, disableGlobalLoading = false) {
    return this.get(url.DOES_TASK_CHAT_ROOM_EXIST, { taskId }, { disableGlobalLoading });
  }

  saveTask(taskV2: SaveTaskV2Request) {
    return this.post(url.SAVE_TASK, taskV2);
  }

  saveTaskFromChatApp(taskV2: SaveTaskV2Request) {
    return this.post(url.SAVE_TASK_FROM_CHAT_APP, taskV2);
  }

  mapTypeIdsToTask(task: Attributes): TaskV2 {
    let type1: string | null = null;
    let typeId1: number | null = null;

    let type2: string | null = null;
    let typeId2: number | null = null;

    if (task.loanId != null) {
      type1 = TaskV2Type.LOAN_ID;
      typeId1 = task.loanId;
    } else if (task.borrowerId != null) {
      type2 = TaskV2Type.BORROWER_ID;
      typeId2 = task.borrowerId;
    } else if (task.propertyId != null) {
      type2 = TaskV2Type.PROPERTY_ID;
      typeId2 = task.propertyId;
    }

    return {
      taskId: task.taskId ?? null,
      type1,
      typeId1,
      type2,
      typeId2,
      information: null,
      templateId: null,
      taskCode: null,
      statusUpdateReason: null,
      category: task.taskType ?? null,
    };
  }

  getAssigneOptions(loanId, loanTaskId, taskId, disableGlobalLoading = false) {
    return this.get(url.GET_ASSIGNEE_OPTIONS, { loanId, loanTaskId, taskId }, { disableGlobalLoading });
  }

  getUserForReadOnlyTasks(loanId: number, loanTaskId: number, taskCode: string, disableGlobalLoading = false) {
    return this.get(url.GET_READ_ONLY_ASSIGNEE_OPTIONS, { loanId, loanTaskId, taskCode }, { disableGlobalLoading });
  }

  getUsersForSupportTaskWatchers(disableGlobalLoading = false) {
    return this.get(url.GET_SUPPORT_TASK_WATCHERS_OPTIONS, {}, { disableGlobalLoading });
  }

  getCurrentWatchersOptions(userIds) {
    return this.post(url.GET_WATCHERS_OPTIONS, userIds);
  }

  uploadAttachment(attachment, file: File) {
    // taskV2/uploadTaskDocument reads the file from the "file" part and the
    // task from the taskId query param; it takes no attachment metadata part.
    const { taskId } = attachment;
    const formData = new FormData();
    formData.append('file', file);

    return this.post(`${url.UPLOAD_ATTACHMENT}?taskId=${taskId}`, formData, {
      'content-type': 'multipart/form-data',
    });
  }

  removeAttachment(taskDocumentId) {
    return this.delete(url.REMOVE_ATTACHMENT, { taskDocumentId });
  }

  downloadDocument(documentId) {
    return this.get(
      `${url.DOCUMENT_DOWNLOAD}?taskDocumentId=${documentId}`);
  }

  saveComments(taskId, comments) {
    return this.post(`${url.SAVE_COMMENTS}?taskId=${taskId}`, comments);
  }

  getLoanInformation(loanIds) {
    const qs = loanIds.map(loanId => `loanId=${loanId}`).join('&');
    return this.get(
      `${url.GET_LOAN_INFO}?${qs}`,
      {},
      { disableGlobalLoading: true }
    );
  }

  escalateTaskToManager(taskId: number) {
    return this.patch(`${url.ESCALATE_TASK_TO_MANAGER}?taskId=${taskId}`, {});
  }

  moveTaskToRoc(taskId: number) {
    return this.post(`${url.MOVE_TASK_TO_ROC}?taskId=${taskId}`, {});
  }

  moveTaskToCapitalProvider(loanTaskId: number) {
    return this.post(`${url.MOVE_TASK_TO_CAPITAL_PROVIDER}?loanTaskId=${loanTaskId}`, {});
  }

  markTaskAsCompleted(taskId: number) {
    return this.post(`${url.MARK_TASK_AS_COMPLETED}?taskId=${taskId}`, {});
  }

  markTaskAsCompletedV2(taskId: number) {
    return this.post(`${url.MARK_TASK_AS_COMPLETED_V2}/${taskId}`, {});
  }

  markTaskAsNotApplicable(taskId: number) {
    return this.post(`${url.MARK_TASK_AS_NOT_APPLICABLE}/${taskId}`, {});
  }

  markTaskAsWaitingOnExternal(loanId: number, propertyId: number, taskType: string) {
    return this.put(`${url.MARK_TASK_AS_WAITING_ON_EXTERNAL}?loanId=${loanId}&propertyId=${propertyId}&taskType=${taskType}`, {});
  }

  putTaskToTpo(taskId: number) {
    return this.post(`${url.PUT_TASK_TO_TPO}?taskId=${taskId}`, {});
  }

  moveTaskToCMTSpecialist(taskId: number) {
    return this.post(`${url.MOVE_TASK_TO_CMT_SPECIALIST}?taskId=${taskId}`, {});
  }

  getAllowedEscalationRoles() {
    return this.get(url.GET_ALLOWED_ESCALATION_ROLES);
  }

  getIsTamariskAppraisal(loanId: number, propertyId: number) {
    return this.get(`${url.IS_TAMARISK_APPRAISAL}?loanId=${loanId}&propertyId=${propertyId}`, {});
  }

  getLoanActorsByLoanId(loanId: number) {
    return this.get(`${url.GET_LOAN_ACTORS_BY_LOAN_ID}?loanId=${loanId}`);
  }

  updateTaskBasedOnLoanTask(taskId, loanTask) {
    return this.post(`${url.UPDATE_TASK_BASED_ON_LOAN_TASK}?taskId=${taskId}`, loanTask);
  }

  getUserTaskssUnreadCountMessages() {
    return this.get(url.GET_UNREAD_COUNT_MESSAGES);
  }

  hasClosingCondition(taskId: number) {
    return this.get(`${url.HAS_CLOSING_CONDITION}?taskId=${taskId}`);
  }

  isStatusChangeReady(taskId: number, status: string) {
    return this.get(url.IS_STATUS_CHANGE_READY, { taskId, status });
  }

  isTaskStatusChangeReady(taskId: number, status: string) {
    return this.get(`${url.IS_TASK_STATUS_CHANGE_READY}`, { taskId, status });
  }

  updateTaskStatusAndAssignee(data: UpdateTaskStatusAndAssigneeRequest) {
    return this.post(url.UPDATE_TASK_STATUS_AND_ASSIGNEE, data);
  }

  updateReadOnlyTaskStatusAndAssignee(data: UpdateReadOnlyTaskStatusAndAssigneeRequest) {
    return this.post(url.UPDATE_READ_ONLY_TASK_STATUS_AND_ASSIGNEE, data);
  }

  updateInternalValuationReportTaskStatusAndAssignee(data: UpdateTaskStatusAndAssigneeRequest) {
    return this.post(url.UPDATE_INTERNAL_VALUATION_REPORT_TASK_STATUS_AND_ASSIGNEE, data);
  }

  saveInternalValuationReviewReason(taskId: number, reason: string) {
    return this.post(url.SAVE_INTERNAL_VALUATION_REVIEW_REASON, { taskId, reason });
  }

  getInternalValuationReasonDropdown(loanId: number, propertyId: number) {
    return this.get(url.GET_INTERNAL_VALUATION_REASON_DROPDOWN, { loanId, propertyId });
  }

  getInternalValuationCurrentReasonDisplay(loanId: number, propertyId: number) {
    return this.get(url.GET_INTERNAL_VALUATION_CURRENT_REASON_DISPLAY, { loanId, propertyId });
  }

  isAssigneeChangeValid(taskId: number, newAssigneeId: number, selectedReason?: string) {
    return this.get(url.IS_ASSIGNEE_CHANGE_VALID, { taskId, newAssigneeId, selectedReason });
  }

  addLoanTask(loanTask: any, isChatApp: boolean = false) {
    const taskCode = loanTask.taskCode
      ?? (loanTask.sectionName === 'SUBJECT_PROPERTY' && loanTask.taskName.toLowerCase().includes('bank statement') ? 'Bank Statement' : 'Manual Task');
    const taskDetails: TaskV2 = {
      title: loanTask.taskName,
      description: loanTask.description,
      status: TaskStatusDB.PENDING,
      priority: loanTask.priority || TaskPriority.MEDIUM,
      ownerId: loanTask.ownerId,
      isSystemTask: false,
      category: loanTask.sectionName,
      type1: TaskV2Type.LOAN_ID,
      typeId1: loanTask.loanId,
      type2: loanTask.type2,
      typeId2: loanTask.type_id2,
      taskCode: taskCode
    };

    const taskAssignee: Assignee = {
      assigneeId: loanTask.assigneeId,
    };

    const taskV2: SaveTaskV2Request = {
      taskDetails: taskDetails,
      assignees: [taskAssignee],
      observers: loanTask.observers,
      isInternal: loanTask.internalTask,
    };

    const requestEndpoint = isChatApp ? url.SAVE_TASK_FROM_CHAT_APP : url.SAVE_TASK;

    return this.post(requestEndpoint, taskV2);
  }

  getLoanTaskSectionNames(loanId: number, loanProcess: string) {
    return this.get(url.GET_LOAN_TASK_CATEGORIES_NAMES, { loanId, loanProcess });
  }

  updateTaskStatus(taskId, status) {
    return this.put(url.UPDATE_TASK_STATUS.replace("{{taskId}}", `${taskId}`), { status });
  }

  assignTaskToOwner(taskId, status, reason) {
    return this.put(`${url.ASSIGN_TASK_TO_OWNER}?taskId=${taskId}`, { status, reason });
  }

  updateTaskStatusReason(taskId, comment) {
    return this.put(`${url.UPDATE_TASK_STATUS_UPDATE_REASON}?taskId=${taskId}`, { comment });
  }

  addTaskNote(taskId, comment) {
    return this.post(url.ADD_TASK_NOTE, { taskId, comment });
  }

  getLoanTasksWithNotes(loanId: number) {
    return this.get(`${url.GET_LOAN_TASKS_WITH_NOTES}?loanId=${loanId}`);
  }

  getTaskByLoanIdAndLoanTaskName(loanId: number, loanTaskName: string) {
    return this.get(url.GET_TASK_BY_LOAN_ID_AND_LOAN_TASK_NAME, { loanId, loanTaskName });
  }

  escalateTask(taskId: number) {
    return this.post(`${url.ESCALATE_TASK_BY_ID}?taskId=${taskId}`, {});
  }

  getRealValPhotoSource(loanId: number, propertyId: number) {
    return this.get(url.REALVAL_PHOTO_SOURCE, { loanId, propertyId });
  }

  changeRealValPhotoSource(loanId: number, propertyId: number, source: string) {
    return this.post(url.REALVAL_PHOTO_SOURCE, { loanId, propertyId, source });
  }
}
